import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getEvents = (params) => async (dispatch) => {
    dispatch({ type: 'CALENDAR_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/calendar', {
            params,
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'EVENTS_SUCCESS', payload: data.events })
        }
    } catch (error) {
        dispatch({ type: 'CALENDAR_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getSchedule = () => async (dispatch) => {
    dispatch({ type: 'CALENDAR_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/schedule', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SCHEDULE_SUCCESS', payload: data.schedule })
        }
    } catch (error) {
        dispatch({ type: 'CALENDAR_ERROR', payload: error.response?.data?.message || error.message })
    }
}
